// extracted by mini-css-extract-plugin
export default {"external":"guest-layout_external__fwAje","always-down-of-page":"guest-layout_always-down-of-page__TRaag"};